export default "__VITE_ASSET__DErIYQEY__"